/** Allowlisted post-login resume paths for GDI gateway (HashRouter). */
const ALLOWED_PREFIXES = [
  "/instructor",
  "/dashboard",
  "/gateway/launch",
  "/pathways/school-university",
];
const RESUME_KEY = "academy_post_login_path";
const GATEWAY_CTX_KEY = "academy_gateway_launch_ctx";

export function isAllowedResumePath(path) {
  if (!path || typeof path !== "string") return false;
  const p = path.startsWith("/") ? path : `/${path}`;
  return ALLOWED_PREFIXES.some((prefix) => p === prefix || p.startsWith(`${prefix}?`) || p.startsWith(`${prefix}/`));
}

function safeSessionSet(key, value) {
  try {
    sessionStorage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
}

function safeSessionGet(key) {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

function safeSessionRemove(key) {
  try {
    sessionStorage.removeItem(key);
  } catch {
    /* Safari private mode */
  }
}

/** Persist opaque launch context for post-login finalize (no PII). */
export function storeGatewayLaunchContext(ctx) {
  if (ctx && typeof ctx === "string" && ctx.length >= 8) {
    safeSessionSet(GATEWAY_CTX_KEY, ctx);
  }
}

export function consumeGatewayLaunchContext() {
  const ctx = safeSessionGet(GATEWAY_CTX_KEY);
  safeSessionRemove(GATEWAY_CTX_KEY);
  return ctx;
}

export function peekGatewayLaunchContext() {
  return safeSessionGet(GATEWAY_CTX_KEY);
}

export function storeLoginResume(path) {
  if (isAllowedResumePath(path)) {
    safeSessionSet(RESUME_KEY, path);
  }
}

export function consumeLoginResume() {
  const path = safeSessionGet(RESUME_KEY);
  safeSessionRemove(RESUME_KEY);
  return isAllowedResumePath(path) ? path : null;
}

/** HashRouter-safe navigation for paths with query strings (WebKit/iPad). */
export function navigateResumePath(navigate, path) {
  if (!path || !isAllowedResumePath(path)) return false;
  const q = path.indexOf("?");
  if (q === -1) {
    navigate(path, { replace: true });
    return true;
  }
  navigate({ pathname: path.slice(0, q), search: path.slice(q) }, { replace: true });
  return true;
}
